export const TestingStatuses = {
  INITIAL: 'initial',
  FAILURE: 'failure',
  SUCCESS: 'success',
  TESTING: 'testing',
};

export const AuthTypes = {
  PRIVATE: 'private',
  RESTRICTED: 'restricted',
  SHARED: 'shared',
};

export const NEW_AUTH_FORM = 'new-auth-form';

export const IS_STALE_AUTH = 'is_stale';
export const SELECTED_API = 'selected_api';
